<template>
    <div>
        <div class="row">
            <div class="col-md-6">
                <div class="form-group">
                    <label>Username
                        <small><span class="redText"> required </span></small>
                    </label>
                    <input type="email" class="form-control" placeholder="Username" v-model="model.userName">
                </div>
                <div class="form-group">
                    <label>Password
                        <small><span class="redText"> required </span></small>
                    </label>
                    <input type="password" class="form-control" placeholder="" v-model="model.password" autocomplete="new-password">
                    <small class="acressaRedText" v-if="!passwordsMatch">Passwords do not match</small>
                </div>
                <div class="form-group">
                    <label>Re-Enter Password
                        <small><span class="redText"> required </span></small>
                    </label>
                    <input type="password" class="form-control" placeholder="" v-model="model.passwordConfirm">
                    <small class="acressaRedText" v-if="!passwordsMatch">Passwords do not match</small>
                </div>
            </div>
            <div class="col-md-6">
                <ul class="pwhelp" style="margin-top: 20px;">
                    <li><h6>Password Requirements</h6></li>
                    <li>Be at least 8 characters in length</li>
                    <li>Contain at least 1 lowercase and 1 uppercase letter</li>
                    <li>Contain at least 1 special character (!@#$%^&amp;*)</li>
                    <li>Contain at least 1 number (0-9)</li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "GenericUserInfo",
        props: {value: {type: [Object], required: true}},
        data() {
            return {
                model: {...this.value},
                originalUsername: this.value.userName
            }
        },
        watch: {
            model: {
                deep: true,
                handler(value) {
                    this.$emit('input', value);
                    this.userNameCheck();
                }
            }
        },
        computed: {
            passwordsMatch() {
                let result = this.model.password == this.model.passwordConfirm;
                //console.log("this.model.password,  this.model.passwordConfirm :", this.model.password, this.model.passwordConfirm);
                return result;
            }
        },
        methods: {
            userNameCheck() {
                //console.log("Inside username check method", this.originalUsername, this.model.userName);
                let result = this.originalUsername != this.model.userName;
                this.model.checkForUniqueUserName = result;
                return result;
            }
        }
    }
</script>

<style scoped>
    @media (max-width: 750px) {
        label {
            margin-top: 10px;
        }
    }
</style>